import React, {Fragment} from "react";
import EscrutinioComponent from "../Conteo/component/EscrutinioComponent.jsx";

const ConteoPages = () => {
    return (
        <Fragment>
            <div className="container">
                <EscrutinioComponent />
            </div>
        </Fragment>
    )
}
export default ConteoPages;
